import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import publishChannel from 'shared/redux/server/actions/channel/publish';

import { normalizeChannel } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (data) {
  return function (dispatch) {
    dispatch(START(data, { data: normalizeChannel(data) }));

    const channelId = data.id;
    const isNewChannel = !channelId;

    const promise = isNewChannel ?
      vodAdapter.list.create(data) :
      vodAdapter.list.update(data);

    return promise
      .then(
        function (response) {
          const normData = normalizeChannel(response.data);

          response = {
            ...response,
            data: normData,
          };

          dispatch(SUCCESS(data, response));

          if (!isNewChannel) {
            return response;
          }

          // new channel - need to publish it
          return dispatch(publishChannel(normData.result))
            .then(() => response);
        },

        function (error) {
          dispatch(FAIL(data, null, { analytics: { type: 'error', name: 'shared.channel.update' } }));
          return error;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/update.js